import { useState, useCallback } from 'react'

const STORAGE_KEY = 'finance.pageSize'
const DEFAULT_PAGE_SIZE = 100

const readStored = (): number => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return DEFAULT_PAGE_SIZE
    const n = parseInt(raw, 10)
    return Number.isFinite(n) && n > 0 ? n : DEFAULT_PAGE_SIZE
  } catch {
    return DEFAULT_PAGE_SIZE
  }
}

/**
 * 共用的財務模組每頁筆數 hook。
 * 任一頁面改動後，下次打開同一頁面或其他財務頁面都沿用此值。
 */
export const useFinancePageSize = (): [number, (next: number) => void] => {
  const [pageSize, setPageSizeState] = useState<number>(() => readStored())

  const setPageSize = useCallback((next: number) => {
    setPageSizeState(next)
    try {
      localStorage.setItem(STORAGE_KEY, String(next))
    } catch {
      // ignore localStorage write failure
    }
  }, [])

  return [pageSize, setPageSize]
}

export const FINANCE_PAGE_SIZE_OPTIONS = [20, 50, 100, 200, 500]
